import {Component} from '@angular/core';

@Component({
    selector: 'app-layout',
    template: '<div class="authentication-container"> <router-outlet></router-outlet> </div>'
})
export class AuthLayoutComponent { }
